module.exports = __webpack_public_path__ + "static/small-business-c0240957baefb63b3eb3fe824a1117a2.jpg";